// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"393":"bac9b4fb59f120b8","956":"dfe06784f410eb97"}[chunkId] + ".js";
};